
  import { Component, Prop, Vue ,Model, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Model('change') private value!:any
    @Prop({
      default:()=>{
        return []
      }
    }) private list!: any;
    @Prop({default:true}) private hasclass!:boolean
    @Prop({default:false}) private dsiabled!:boolean
    private index = 1

    @Watch('value')
    private changevalue(val){
      this.index = val
    }

    private mounted () {
      // console.log(this.$slots)
      this.index = this.list[0].value
    }
    private chooselabel(e){
      if(this.dsiabled) return 
      this.$emit('change',e.value)
    }
  }
